import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  useMediaQuery,
  DialogContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from '@material-ui/core';

// STYLES
import { DialogStyled, MenuStyled } from './styles';

const DialogMenuActions = ({ className, type, actions, ...props }) => {
  const downXs = useMediaQuery(({ breakpoints }) => breakpoints.down('xs'));

  const listItems = actions.map(
    (
      { title = '', icon = null, onClick = () => {}, hoc, hocProps = {}, ...restProps },
      idx,
      arr,
    ) => {
      return (
        <div key={idx}>
          {React.createElement(
            hoc || React.Fragment,
            {
              ...(hoc ? hocProps : {}),
            },
            <ListItem
              className="dialog-menu-actions__list-item"
              button
              onClick={() => {
                props.onClose();
                onClick();
              }}
              {...restProps}
            >
              {downXs && (
                <ListItemIcon className="dialog-menu-actions__list-item-icon">{icon}</ListItemIcon>
              )}
              <ListItemText
                className="dialog-menu-actions__list-item-text"
                primary={title}
                primaryTypographyProps={{
                  variant: 'body1',
                }}
              />
            </ListItem>,
          )}

          {!(arr.length - 1 === idx) && <Divider className="dialog-menu-actions__divider" />}
        </div>
      );
    },
  );

  if (type === 'only-dialog' || (downXs && type === 'default')) {
    return (
      <DialogStyled
        fullWidth
        {...props}
        className={clsx('dialog-menu-actions', className)}
        PaperProps={{ className: 'dialog-menu-actions__paper' }}
      >
        <DialogContent className="dialog-menu-actions__dialog-content">
          <List className="dialog-menu-actions__list" disablePadding>
            {listItems}
          </List>
        </DialogContent>
      </DialogStyled>
    );
  }

  if (type === 'only-menu' || (!downXs && type === 'default')) {
    return (
      <MenuStyled
        className={clsx('dialog-menu-actions', className)}
        id="actions-menu"
        keepMounted
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        PaperProps={{
          elevation: 7,
        }}
        MenuListProps={{
          className: 'dialog-menu-actions__list',
        }}
        {...props}
      >
        {listItems}
      </MenuStyled>
    );
  }

  return null;
};

DialogMenuActions.defaultProps = {
  className: '',
  type: 'default', // default | only-dialog | only-menu
  actions: [],
  onClose: () => {},
};

DialogMenuActions.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  open: PropTypes.bool.isRequired,
  actions: PropTypes.array,
  onClose: PropTypes.func,
};

export default React.memo(DialogMenuActions);
